<template>
  <OnedayTeenPatti v-if="type=='oneday-teen-patti'"/>
  <T20TeenPatti v-if="type=='t20-teen-patti'"/>
  <Poker v-if="type=='poker'"/>
  <AndharBahar v-if="type=='andhar-bahar'"/>
  <Sevenup7down v-if="type=='7up7down'"/>
  <ThirtyTwocards v-if="type=='32-cards'"/>
  <DragonTiger v-if="type=='dragon-tiger'"/>
  <AmarAkbarAntony v-if="type=='amar-akbar-antony'"/>
  <WorliMatka v-if="type=='worli-matka'"/>
</template>

<script>
import OnedayTeenPatti from '../components/livecard-components/OnedayTeenPatti'
import T20TeenPatti from '../components/livecard-components/T20TeenPatti'
import Poker from '../components/livecard-components/Poker.vue'
import AndharBahar from '../components/livecard-components/AndharBahar.vue'
import Sevenup7down from '../components/livecard-components/7up7down.vue'
import ThirtyTwocards from '../components/livecard-components/32Cards.vue'
import DragonTiger from '../components/livecard-components/DragonTiger.vue'
import AmarAkbarAntony from '../components/livecard-components/AmarAkbarAntony.vue'
import WorliMatka from '../components/livecard-components/WorliMatka.vue'

export default{
    name:'LiveCardDetails',
    components:{
      OnedayTeenPatti,
      T20TeenPatti,
      Poker,
      AndharBahar,
      Sevenup7down,
      ThirtyTwocards,
      DragonTiger,
      AmarAkbarAntony,
      WorliMatka,
    },
    data(){
      return{
        type:null
      }
    },
    mounted(){
      this.type=this.$route?.params?.type
    },
    methods:{

    }
}
</script>